import { ref } from 'vue'

/**
 * 监听鼠标滚轮（向下滚）或手指向上滑动
 */
export function useWheelOrSwipeUpListener() {
  let lastTouchY = 0
  const isTrigger = ref(false)

  // 鼠标滚轮监听
  function onWheel(e: WheelEvent) {
    if (e.deltaY > 0)
      changeIsTrigger()
  }

  // 手指触摸监听
  function onTouchStart(e: TouchEvent) {
    if (e.touches.length)
      lastTouchY = e.touches[0].clientY
  }

  function onTouchMove(e: TouchEvent) {
    if (!e.touches.length)
      return
    const currentY = e.touches[0].clientY
    if (lastTouchY - currentY > 40) { // 向上滑，阈值可调整
      changeIsTrigger()
    }
    lastTouchY = currentY
  }

  let triggerTimer: ReturnType<typeof setTimeout> | null = null
  function changeIsTrigger() {
    isTrigger.value = true
    if (triggerTimer)
      clearTimeout(triggerTimer)
    triggerTimer = setTimeout(() => {
      isTrigger.value = false
      triggerTimer = null
    }, 2000)
  }

  function listenWheelOrSwipeUp() {
    window.addEventListener('wheel', onWheel)
    window.addEventListener('touchstart', onTouchStart)
    window.addEventListener('touchmove', onTouchMove)
  }

  function removeWheelOrSwipeUpListener() {
    window.removeEventListener('wheel', onWheel)
    window.removeEventListener('touchstart', onTouchStart)
    window.removeEventListener('touchmove', onTouchMove)

    if (triggerTimer)
      clearTimeout(triggerTimer)
  }

  return {
    isTrigger,
    listenWheelOrSwipeUp,
    removeWheelOrSwipeUpListener,
  }
}
